/**
 * Fixed texts a run posts when it stops calling tools. They are stored in English; clients
 * recognize them by template to show them in the reader's language.
 */

const LOOP_GUARD_STOP_PREFIX = "I got stuck calling ";
const LOOP_GUARD_STOP_COUNT_PREFIX = " with the same input ";
const LOOP_GUARD_STOP_SUFFIX =
  " times in a row without making progress, so I stopped early. Try rephrasing this, or ask me to try a different approach.";
const LOOP_GUARD_STOP_PATTERN = new RegExp(
  `^${LOOP_GUARD_STOP_PREFIX}(.+)${LOOP_GUARD_STOP_COUNT_PREFIX}(\\d+)${LOOP_GUARD_STOP_SUFFIX.replaceAll(".", "\\.")}$`,
);

/** The reply that ends a run stuck repeating one call; `toolName` is the step label. */
export function loopGuardStopText(toolName: string, count: number): string {
  return `${LOOP_GUARD_STOP_PREFIX}${toolName}${LOOP_GUARD_STOP_COUNT_PREFIX}${count}${LOOP_GUARD_STOP_SUFFIX}`;
}

export function parseLoopGuardStopText(text: string): { tool: string; count: number } | undefined {
  const match = text.match(LOOP_GUARD_STOP_PATTERN);
  return match?.[1] && match[2] ? { tool: match[1], count: Number(match[2]) } : undefined;
}

export function isLoopGuardStopText(text: string): boolean {
  return parseLoopGuardStopText(text) !== undefined;
}

const TOOL_BUDGET_STOP_PATTERN = /^Stopped: more than (\d+) tool calls in one turn\.$/;

/** The status a turn shows when it passes its tool-call limit. */
export function toolBudgetStopText(limit: number): string {
  return `Stopped: more than ${limit} tool calls in one turn.`;
}

export function parseToolBudgetStopText(text: string): { limit: number } | undefined {
  const match = text.trim().match(TOOL_BUDGET_STOP_PATTERN);
  return match?.[1] ? { limit: Number(match[1]) } : undefined;
}
